import { useWatch } from 'react-hook-form';

import Box from 'shared_DEPRECATED/components/Box';
import { FileDownloadButton } from 'shared_DEPRECATED/components/File';
import { UploadedFile } from 'shared_DEPRECATED/components/File/UploadedFile';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';
import { Attachment } from 'shared_DEPRECATED/types/Attachment';

import { SessionsFormCoachingToolsSection } from 'features/sessions/components/Form/CoachingTools';

import { ButtonIcon } from 'shared/components/Button';

type SessionsFormCoachingToolsMiroBoardAttachmentsListProps = {
  formKey: string;
  onDelete?: (index: number) => void;
};

export const SessionsFormCoachingToolsMiroBoardsList = ({
  formKey,
  onDelete,
}: SessionsFormCoachingToolsMiroBoardAttachmentsListProps) => {
  const miroBoards: Attachment[] = useWatch({ name: formKey }) || [];

  if (!miroBoards || miroBoards.length === 0) {
    return null;
  }

  return (
    <SessionsFormCoachingToolsSection>
      <Spacer size="md zr" />
      <Box
        style={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: 'var(--spacing04)',
        }}
      >
        {miroBoards.map((attachment, index) => (
          <UploadedFile
            key={attachment.attachmentId || index}
            name={attachment.name}
            contentType={attachment.contentType}
          >
            {attachment.url && (
              <FileDownloadButton url={attachment.url} name={attachment.name} />
            )}
            {onDelete && (
              <ButtonIcon
                aria-label="remove file"
                onClick={() => onDelete(index)}
                variant="ghost"
              >
                <Icon name={iconNames.cross} />
              </ButtonIcon>
            )}
          </UploadedFile>
        ))}
      </Box>
    </SessionsFormCoachingToolsSection>
  );
};
